import { computed, ref } from "vue"
import { useStore } from "@/store";

class ComponenteModuloService {
    setup() {
        const store = useStore()
        const telefone = ref('')
        const email = ref('')
        const exibirLoader = ref(false)
        const dadosAtendimento = computed(() => store.state.dadosAtendimento)
        return { dadosAtendimento, telefone, email, exibirLoader }
    }
}

export default new ComponenteModuloService();